import { CheckCircleIcon } from '@heroicons/react/24/solid'

export default function CheckboxInputButton({
  emoji,
  id,
  name,
  onChange,
  subtitle,
  title,
  value,
}: {
  emoji: string
  id: string
  name: string
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  subtitle?: string
  title: string
  value?: string
}) {
  return (
    <div className="group flex">
      <input
        className="hidden"
        id={id}
        name={name}
        onChange={onChange}
        type="checkbox"
        value={value || id}
      />

      <label
        className="bg-custom-green group-has-[:checked]:border-primary flex w-full cursor-pointer items-center gap-3 rounded-xl border border-[#EAEAEA] bg-white p-3 hover:scale-102 hover:opacity-80 hover:drop-shadow-lg"
        htmlFor={id}
      >
        <span className="shrink-0 rounded-lg bg-[#F5FBFF] px-2 py-1 text-xl">
          {emoji}
        </span>

        <div className="flex grow flex-col">
          <span className="text-custom-black font-bold">{title}</span>

          {subtitle && (
            <span className="text-sm text-[#757575]">{subtitle}</span>
          )}
        </div>

        <CheckCircleIcon className="text-primary h-6 w-6 shrink-0 opacity-0 transition-opacity group-has-[:checked]:opacity-100" />
      </label>
    </div>
  )
}
